import { HotelUpdateSearchModalType } from "@website/accommodation-ui/hotel-update-search-modal/hotel-update-search-modal.types";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { Modal } from "@website/ui/modal";
import { deepCompare } from "@website/utils/deep-compare";
import { FC, memo } from "react";

const Component: FC<HotelUpdateSearchModalType> = (properties) => {
  const { onUpdateResult, isOpen, msg, isLoading } = properties;

  const message =
    msg ||
    (process.env.NEXT_PUBLIC_APP_NAME === "villa"
      ? "قیمت و ظرفیت اقامتگاه‌ها دائما در حال تغییر هستند. برای اطمینان از آخرین قیمت و وضعیت اقامتگاه‌ها، لطفا جستجو را بروز‌رسانی نمایید."
      : "قیمت و ظرفیت هتل‌ها دائما در حال تغییر هستند. برای اطمینان از آخرین قیمت و وضعیت هتل‌ها، لطفا جستجو را بروز‌رسانی نمایید.");
  return (
    <Modal
      open={isOpen}
      onClose={() => undefined}
      showCloseButton={false}
      mobileHeight="auto"
      animate="bottom"
    >
      <div className="lg:w-[400px]">
        <div className="flex">
          <MaterialIcon
            className="text-on-surface-medium-emphasis text-xl"
            name="history"
          />
          <h3 className="text-headline-6 pr-4">بروزرسانی جستجو</h3>
        </div>
        <div className="text-body-2 text-on-surface-high-emphasis pb-10 pt-6">
          {message}
        </div>
        <Button
          loading={isLoading}
          size="large"
          children="بروزرسانی جستجو"
          color="secondary"
          fullWidth
          onClick={onUpdateResult}
        />
      </div>
    </Modal>
  );
};

export const HotelUpdateSearchModal = memo(Component, deepCompare);
